import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c8f254c0")

_pushScopeId("data-v-c8f254c0")
const _hoisted_1 = { class: "w-full flex flex-col bg-white" }
const _hoisted_2 = {
  key: 1,
  class: "w-14 px-3 py-3 text-sm text-gray-700"
}
const _hoisted_3 = {
  key: 0,
  class: "w-12 px-3 py-3 flex text-gray-400"
}
const _hoisted_4 = {
  key: 1,
  class: "w-20 px-3 py-3 flex"
}
const _hoisted_5 = { class: "flex items-center p-1 rounded-md cursor-pointer text-sm text-gray-500 hover:bg-gray-100" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 閲覧")
const _hoisted_7 = {
  key: 2,
  class: "w-31 px-3 py-3 flex text-gray-400"
}
const _hoisted_8 = { class: "w-12 px-4 py-3 flex ml-auto text-gray-400" }
const _hoisted_9 = {
  key: 1,
  class: "w-full flex items-center"
}
const _hoisted_10 = {
  key: 1,
  class: "w-14 px-3 py-3 text-sm text-gray-700"
}
const _hoisted_11 = {
  key: 0,
  class: "w-12 px-3 py-3 flex text-gray-400"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_table_cell = _resolveComponent("m-table-cell")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rowDatas, (row, index) => {
      return (_openBlock(), _createBlock("li", {
        key: row.id,
        class: "border-t border-gray-200",
        style: { backgroundColor: row.color }
      }, [
        (row.link)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: row.link,
              class: "w-full flex items-center transition-all duration-300 hover:bg-gray-200",
              onMouseenter: _ctx.handleMouseEnter,
              onMouseleave: _ctx.handleMouseLeave
            }, {
              default: _withId(() => [
                _createVNode("div", {
                  class: [
            'flex',
            'items-center',
            row.pinnedDatas.length > 0 ? 'sticky-container' : '',
            _ctx.rowDatas.length === index + 1 ? 'last-row' : ''
          ]
                }, [
                  (_ctx.selectable)
                    ? (_openBlock(), _createBlock("label", {
                        key: 0,
                        for: `checkbox-${row.order}`,
                        class: "w-12 px-4 py-6 hidden lg:flex text-gray-400",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode("input", {
                          id: `checkbox-${row.order}`,
                          type: "checkbox",
                          name: "select",
                          checked: row.select,
                          class: "cursor-pointer",
                          disabled: _ctx.disableSelection ?? false,
                          onChange: ($event: any) => (_ctx.change(row.id))
                        }, null, 40, ["id", "checked", "disabled", "onChange"])
                      ], 8, ["for"]))
                    : _createCommentVNode("", true),
                  (_ctx.order)
                    ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(row.order), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.pinnedDatas, (data, dataIndex) => {
                    return (_openBlock(), _createBlock(_component_m_table_cell, {
                      key: `${row.order}_${dataIndex}_${data.text}`,
                      text: data.text,
                      prefix: data.prefix,
                      suffix: data.suffix,
                      size: data.size,
                      "max-size": data.maxSize,
                      "show-on-mobile": data.showOnMobile,
                      "extra-class": data.extraClass,
                      property: data.property,
                      hover: data.hover,
                      copyable: data.copyable ?? false,
                      "user-id": row.id,
                      "school-a-i-user-id": row.schoolAIUserId,
                      "school-doc-id": row.schoolDocId,
                      "classroom-doc-id": row.classroomDocId,
                      "is-button": data.isButton ?? false,
                      button: data.button ?? null,
                      onClick: ($event: any) => (_ctx.onCustomButtonClick(row.id, $event))
                    }, null, 8, ["text", "prefix", "suffix", "size", "max-size", "show-on-mobile", "extra-class", "property", "hover", "copyable", "user-id", "school-a-i-user-id", "school-doc-id", "classroom-doc-id", "is-button", "button", "onClick"]))
                  }), 128))
                ], 2),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.scrollableDatas, (data, dataIndex) => {
                  return (_openBlock(), _createBlock(_component_m_table_cell, {
                    key: `${row.order}_${dataIndex}_${data.text}`,
                    text: data.text,
                    prefix: data.prefix,
                    suffix: data.suffix,
                    size: data.size,
                    "max-size": data.maxSize,
                    "show-on-mobile": data.showOnMobile,
                    "extra-class": data.extraClass,
                    property: data.property,
                    hover: data.hover,
                    copyable: data.copyable ?? false,
                    "user-id": row.id,
                    "school-a-i-user-id": row.schoolAIUserId,
                    "school-doc-id": row.schoolDocId,
                    "classroom-doc-id": row.classroomDocId,
                    "is-button": data.isButton ?? false,
                    button: data.button ?? null,
                    onClick: ($event: any) => (_ctx.onCustomButtonClick(row.id, $event))
                  }, null, 8, ["text", "prefix", "suffix", "size", "max-size", "show-on-mobile", "extra-class", "property", "hover", "copyable", "user-id", "school-a-i-user-id", "school-doc-id", "classroom-doc-id", "is-button", "button", "onClick"]))
                }), 128)),
                (_ctx.editable)
                  ? (_openBlock(), _createBlock("div", _hoisted_3, [
                      _createVNode("div", {
                        class: "p-1 rounded-md cursor-pointer hover:bg-gray-100",
                        onClick: _withModifiers(($event: any) => (_ctx.select(row.id)), ["prevent"])
                      }, [
                        _createVNode(_component_m_icon, { type: "pencil" })
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.useSubmission)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      (row.relatedLink)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: row.relatedLink,
                            target: "_blank",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createVNode(_component_m_icon, { type: "popup" })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.useActions)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("div", {
                          class: "p-1 rounded-md cursor-pointer hover:bg-gray-100 mr-2",
                          onClick: _withModifiers(($event: any) => (_ctx.select(row.id)), ["prevent"])
                        }, [
                          _createVNode(_component_m_icon, {
                            type: "pencil",
                            size: "4"
                          })
                        ], 8, ["onClick"]),
                        _createVNode("div", {
                          class: "p-1 rounded-md cursor-pointer hover:bg-gray-100",
                          onClick: _withModifiers(($event: any) => (_ctx.copy(row.id)), ["prevent"])
                        }, [
                          _createVNode(_component_m_icon, { type: "clipboard-copy" })
                        ], 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_m_icon, { type: "chevron-right" })
                ])
              ]),
              _: 2
            }, 1032, ["to", "onMouseenter", "onMouseleave"]))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", {
                class: [
            'flex',
            'items-center',
            row.pinnedDatas.length > 0 ? 'sticky-container' : '',
            _ctx.rowDatas.length === index + 1 ? 'last-row' : ''
          ]
              }, [
                (_ctx.selectable)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "w-12 px-4 py-3 hidden lg:flex text-gray-400",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createVNode("input", {
                        type: "checkbox",
                        name: "select",
                        checked: row.select,
                        class: "cursor-pointer",
                        disabled: _ctx.disableSelection ?? false,
                        onChange: ($event: any) => (_ctx.change(row.id))
                      }, null, 40, ["checked", "disabled", "onChange"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.order)
                  ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(row.order), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.pinnedDatas, (data) => {
                  return (_openBlock(), _createBlock(_component_m_table_cell, {
                    key: data.text,
                    text: data.text,
                    prefix: data.prefix,
                    suffix: data.suffix,
                    size: data.size,
                    "max-size": data.maxSize,
                    "show-on-mobile": data.showOnMobile,
                    hover: data.hover,
                    copyable: data.copyable ?? false,
                    class: "lg:flex",
                    "is-button": data.isButton ?? false,
                    button: data.button ?? null,
                    onClick: ($event: any) => (_ctx.onCustomButtonClick(row.id, $event))
                  }, null, 8, ["text", "prefix", "suffix", "size", "max-size", "show-on-mobile", "hover", "copyable", "is-button", "button", "onClick"]))
                }), 128))
              ], 2),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.scrollableDatas, (data) => {
                return (_openBlock(), _createBlock(_component_m_table_cell, {
                  key: data.text,
                  text: data.text,
                  prefix: data.prefix,
                  suffix: data.suffix,
                  size: data.size,
                  "max-size": data.maxSize,
                  "show-on-mobile": data.showOnMobile,
                  hover: data.hover,
                  copyable: data.copyable ?? false,
                  class: "lg:flex",
                  "is-button": data.isButton ?? false,
                  button: data.button ?? null,
                  onClick: ($event: any) => (_ctx.onCustomButtonClick(row.id, $event))
                }, null, 8, ["text", "prefix", "suffix", "size", "max-size", "show-on-mobile", "hover", "copyable", "is-button", "button", "onClick"]))
              }), 128)),
              (_ctx.editable)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", {
                      class: "p-1 rounded-md cursor-pointer hover:bg-gray-100",
                      onClick: ($event: any) => (_ctx.select(row.id))
                    }, [
                      _createVNode(_component_m_icon, { type: "pencil" })
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ], 4))
    }), 128))
  ]))
})